import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogFooter from './DialogFooter';

const NoResponse = (props)=>{
	const close = ()=>{

	}

	return (
		<Dialog open={props.open} onClose={close} aria-labelledby="dialog-noresponse">
			<DialogTitle id="form-dialog-title">サーバー応答なし</DialogTitle>
			<DialogContent>
				<DialogContentText>
					サーバーからの応答がありませんでした。<br/>
					回線の混雑もしくはサーバーの動作に異常が発生している可能性があります。<br/>
					しばらく待ってから再度お試しください。<br/>
				</DialogContentText>
				<DialogFooter/>
			</DialogContent>
			<DialogActions>
			</DialogActions>
		</Dialog>
	)
}

export default NoResponse;